import React from 'react';
import './App.css';
import SNAppClone from './components/SNAppCloner/SNAppCloner';

function App() {
  return (
    <div className="App">
      <SNAppClone></SNAppClone>
    </div>
  );
}

export default App;
